import React from "react";
import { Divider, Typography } from "@mui/material";
import "../index.css"
export const AcercaDe = () => {
  return (
    <>
      <div style={{ textAlign: "center" }}>
        <img
          src="https://res.cloudinary.com/canaclc/image/upload/v1647638811/induimages/quienes-somos_brgz0v.jpg"
          alt=""
        ></img>
      </div>

      <Divider className="divider">Historia</Divider>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        color="textPrimary"
        marginTop={5}
        align="center"
        component="p"
        gutterBottom
      >
        Indubolsas Popayán es un negocio familiar que empezó en 1981, a través
        de la necesidad de sus clientes de contar con un aliado integral que
        suministre productos de empaque de calidad con ANS superiores;
        brindándoles a nuestros clientes más beneficios en calidad y costos,
        contando con fabricantes en cada una de las líneas de los productos
        comercializados, convirtiendose en su partner de negocio.
      </Typography>
      <Divider className="divider">Mision</Divider>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="textPrimary"
        component="p"
        gutterBottom
        align="center"
      >
        Comercializar bolsas y todo lo relacionado para el empaque
      </Typography>
      <Divider className="divider">Vision</Divider>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="textPrimary"
        component="p"
        gutterBottom
        align="center"
      >
        Comercializar bolsas y todo lo relacionado para el empaque
      </Typography>
      <Divider className="divider">
        Politica de calidad
      </Divider>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="textPrimary"
        component="p"
        gutterBottom
        align="center"
      >
        En Indubolsas Popayán, nuestro mayor propósito es el crecimiento y la
        satisfacción de nuestros clientes con una buena atención, buena calidad
        de nuestros productos, con buenos precios para el mercado y garantizando
        las entregas en el tiempo estipulado. Podrás encontrar toda la variedad
        que necesites de empaques para tu negocio ya que contamos con una gama
        alta de distribuidores
      </Typography>
      <Divider className="divider">
        Valores Corporativos
      </Divider>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="#D35400"
        component="p"
        gutterBottom
        align="center"
      >
        Amabilidad
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        color="textPrimary"
        marginTop={5}
        component="p"
        gutterBottom
        align="center"
      >
        Favorecer un ambiente de trabajo armónico, generando una mayor
        colaboración en los equipos de trabajo. con las necesidades de nuestros
        clientes de forma rápida, complacientes y efectivos.
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="#D35400"
        component="p"
        gutterBottom
        align="center"
      >
        Calidad
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="textPrimary"
        component="p"
        gutterBottom
        align="center"
      >
        Todos dicen que tienen los mejores productos del mercado. Pero una cosa
        es afirmarlo y la otra es generando confianza a través de la
        comunicación abierta hacia nuestros clientes.
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="#D35400"
        component="p"
        gutterBottom
        align="center"
      >
        Crecimiento
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="textPrimary"
        component="p"
        gutterBottom
        align="center"
      >
        Nuestro mayor propósito es ayudar al crecimiento de nuestros clientes,
        mediante una interacción directa, enviándoles promociones y mensajes
        para que nos sigan eligiendo.
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="#D35400"
        component="p"
        gutterBottom
        align="center"
      >
        Éxito
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="textPrimary"
        component="p"
        gutterBottom
        align="center"
      >
        Estos factores son fundamentales para el éxito de la empresa:
        creatividad, tolerancia al riesgo (una alerta para evitar llegar a la
        capacidad de riesgo, capacidad de respuesta a las oportunidades,
        liderazgo y la capacidad de aprovechar los derechos que se le otorgan.
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="#D35400"
        component="p"
        gutterBottom
        align="center"
      >
        Optimismo
      </Typography>
      <Typography
        className="animate__animated animate__fadeIn"
        variant="body1"
        fontSize={19}
        marginBottom={5}
        marginTop={5}
        color="textPrimary"
        component="p"
        gutterBottom
        align="center"
      >
        Es mantener una actitud positiva confiando en que cada situación adversa
        pasará y saldremos más fortalecidos.
      </Typography>
    </>
  );
};
